import { styled } from '@mui/system';

export const MainContainer = styled("div")(({ theme }) => ({
  paddingTop: "50px",
  backgroundColor: "#ffffdc",
  [theme.breakpoints.up('md')]: {
    paddingTop: "0px",
  },
}));